module.exports = __webpack_public_path__ + "media/images/antispam-5badebdf.svg";